/* SIX PACK — efectos de entrada de la portada.
   1) Carrete de los 3 pilares: un punto se abre en manchas líquidas (metaballs) que revelan los símbolos
      de cada pilar; con el scroll se ordenan en un tríptico.
   2) Cada foto de las fases entra con una revelación circular. */
(function () {
  "use strict";
  var css = document.createElement("style");
  css.textContent = [
    ".reel5{position:relative;height:330vh;background:var(--abismo)}",
    ".reel5 .stick5{position:sticky;top:0;height:100vh;height:100svh;overflow:hidden;background:radial-gradient(90% 70% at 50% 45%,#16304f 0%,#0B1A2E 60%,#060f1c 100%)}",
    ".reel5 .tiles5{position:absolute;inset:0;perspective:1400px;perspective-origin:50% 45%}",
    ".reel5 .t5{position:absolute;left:50%;top:46%;margin:0;transform-style:preserve-3d;will-change:transform}",
    ".reel5 .t5 .fr{position:relative;width:100%;height:100%;overflow:hidden;border-radius:3px;background:#0d1a2b;box-shadow:0 40px 80px -30px rgba(0,0,0,.65),0 0 0 1px rgba(184,146,90,.28)}",
    ".reel5 .t5 img{position:absolute;inset:-5%;width:110%;height:110%;max-width:none;object-fit:cover;display:block;animation:kb5 18s ease-in-out infinite alternate}",
    "@keyframes kb5{from{transform:scale(1) translate(0,0)}to{transform:scale(1.07) translate(-1.6%,-1.2%)}}",
    ".reel5 .t5 figcaption{position:absolute;left:0;right:0;top:calc(100% + 16px);display:flex;flex-direction:column;gap:4px;color:var(--hueso);opacity:0}",
    ".reel5 .t5 figcaption .mono{color:var(--laton)}",
    ".reel5 .t5 figcaption b{font-size:clamp(22px,2.4vw,38px);font-weight:300;letter-spacing:-.03em;line-height:1}",
    ".reel5 .t5 figcaption small{font-size:13px;color:var(--niebla);line-height:1.45}",
    ".reel5 .head5{position:absolute;left:var(--g-l);right:var(--g-r);top:calc(96px + env(safe-area-inset-top,0px));display:grid;grid-template-columns:minmax(0,3fr) minmax(0,9fr);gap:24px;opacity:0}",
    ".reel5 .head5 .mono{color:var(--niebla);padding-top:12px}",
    ".reel5 .head5 h2{margin:0;font-size:clamp(34px,4.6vw,76px);line-height:.95;font-weight:300;letter-spacing:-.045em;color:var(--hueso)}",
    ".reel5 canvas.goo5{position:absolute;inset:0;width:100%;height:100%;display:block;pointer-events:none;z-index:3}",
    ".reel5 .hint5{position:absolute;left:50%;bottom:28px;transform:translateX(-50%);z-index:4;color:var(--abismo);opacity:.7}",
    "@media (max-width:820px){.reel5{height:300vh}.reel5 .head5{grid-template-columns:1fr;gap:8px}.reel5 .t5 figcaption{top:calc(100% + 10px)}.reel5 .t5 figcaption b{font-size:20px}.reel5 .t5 figcaption small{display:none}}",
    // Revelación líquida de los videos
    "html.js .meth .fig4[data-rv]{clip-path:circle(6% at 50% 58%);transition:clip-path 1.6s cubic-bezier(.2,.7,.2,1)!important}",
    "html.js .meth .fig4[data-rv].on{clip-path:circle(85% at 50% 50%)}",
    "html.js .phz .plist4 .fig4{clip-path:circle(6% at 50% 58%);transition:clip-path 1.5s cubic-bezier(.2,.7,.2,1)!important}",
    "html.js .phz .plist4 .fig4.in{clip-path:circle(85% at 50% 50%)}",
    ".pcard4.on .fig4{animation:blob5 1.3s cubic-bezier(.2,.7,.2,1) both!important}",
    "@keyframes blob5{from{clip-path:circle(5% at 50% 60%)}to{clip-path:circle(85% at 50% 50%)}}",
    ".fig4 video{transition:filter .6s}",
    // Fotos reales: entran en blanco y negro y toman color
    "html.js .meth .fig4[data-rv] img,html.js .phz .plist4 .fig4 img{filter:grayscale(1) brightness(.75);transition:filter 1.8s cubic-bezier(.2,.7,.2,1)}",
    "html.js .meth .fig4[data-rv].on img,html.js .phz .plist4 .fig4.in img{filter:none}",
    // Símbolos de los pilares: se dibujan al entrar y siguen vivos
    ".sym6{position:absolute;inset:0;display:grid;place-items:center;overflow:hidden;color:#C9A36B;background:radial-gradient(85% 75% at 50% 38%,#1d3a5f 0%,#11233c 55%,#0a1628 100%)}",
    ".sym6 svg{position:relative;z-index:1;width:84%;height:auto;max-height:84%;overflow:visible;filter:drop-shadow(0 0 16px rgba(201,163,107,.22))}",
    ".sym6 .g6{position:absolute;inset:0;background-image:linear-gradient(rgba(201,163,107,.07) 1px,transparent 1px),linear-gradient(90deg,rgba(201,163,107,.07) 1px,transparent 1px);background-size:22px 22px;-webkit-mask-image:radial-gradient(70% 60% at 50% 45%,#000,transparent);mask-image:radial-gradient(70% 60% at 50% 45%,#000,transparent);pointer-events:none}",
    ".sym6 .sd{stroke-dasharray:1;stroke-dashoffset:1;transition:stroke-dashoffset 2.4s cubic-bezier(.65,0,.25,1)}",
    ".sym6 .f{stroke-opacity:.45}",
    ".sym6 g .sd{transition-delay:.2s}.sym6 .a1,.sym6 .a2{transition-delay:.9s}.sym6 .sun .sd{transition-delay:.7s}",
    ".sym6 .dot{fill:#C9A36B;opacity:0;transition:opacity 1s 1.6s}",
    ".in6 .sym6 .sd,.fig4.on .sym6 .sd{stroke-dashoffset:0}",
    ".in6 .sym6 .dot,.fig4.on .sym6 .dot{opacity:1}",
    // Animaciones de los símbolos (pilares y fases)
    ".sym6 .db,.ph6 .db{transform-box:view-box;animation:db6 2.6s cubic-bezier(.45,0,.3,1) infinite}",
    "@keyframes db6{0%,100%{transform:translateY(12px)}50%{transform:translateY(-16px)}}",
    ".sym6 .ml,.ph6 .ml{animation:ml6 2.6s cubic-bezier(.45,0,.3,1) infinite}",
    "@keyframes ml6{0%,100%{opacity:.9}50%{opacity:.1}}",
    ".sym6 .sp,.ph6 .sp{transform-box:view-box;transform-origin:105px 162px;animation:sp6 4.5s ease-in-out infinite}",
    "@keyframes sp6{0%,100%{transform:rotate(-5deg) scale(.96)}50%{transform:rotate(5deg) scale(1.04)}}",
    ".ck{stroke-dasharray:1;stroke-dashoffset:1;animation:ck6 5.6s ease-in-out infinite}",
    ".k1{animation-delay:.35s}.k2{animation-delay:.7s}.k3{animation-delay:1.05s}.k4{animation-delay:1.4s}.k5{animation-delay:1.75s}.k6{animation-delay:2.1s}",
    "@keyframes ck6{0%,8%{stroke-dashoffset:1}22%,80%{stroke-dashoffset:0}94%,100%{stroke-dashoffset:1}}",
    ".fl{animation:fl6 1.6s ease-in infinite}@keyframes fl6{0%{transform:translateY(-8px);opacity:0}30%{opacity:1}100%{transform:translateY(12px);opacity:0}}",
    ".drp{animation:dr6 1.6s ease-in infinite .8s}@keyframes dr6{0%{transform:translateY(-4px);opacity:0}40%{opacity:1}100%{transform:translateY(8px);opacity:0}}",
    ".tb{animation:tb6 3.2s cubic-bezier(.3,0,.2,1) infinite}@keyframes tb6{0%{transform:translateY(-34px);opacity:0}25%{opacity:1}50%,86%{transform:none;opacity:1}100%{transform:none;opacity:0}}",
    ".ln{stroke-dasharray:1;animation:ln6 4s ease-in-out infinite}@keyframes ln6{0%{stroke-dashoffset:1}45%,85%{stroke-dashoffset:0}100%{stroke-dashoffset:-1}}",
    ".fg{transform-box:view-box;transform-origin:132px 40px;animation:fg6 2.2s ease-in-out infinite}@keyframes fg6{0%,100%{transform:skewY(0) scaleX(1)}50%{transform:skewY(6deg) scaleX(.86)}}",
    // Fases: carrusel que avanza solo (referente: casaenzocoffee.com)
    ".phz6 .hd6{display:flex;justify-content:space-between;align-items:flex-end;gap:24px}",
    ".phz6 .hd6 .sh{flex:1}",
    ".nav6{display:flex;gap:10px;flex:none}",
    ".nav6 button{width:48px;height:48px;border-radius:50%;border:1px solid rgba(201,163,107,.5);background:transparent;color:var(--hueso);display:grid;place-items:center;cursor:pointer;transition:background .3s,color .3s}",
    ".nav6 button:hover{background:#C9A36B;color:#0B1A2E}",
    ".rail6{display:flex;gap:18px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-ms-overflow-style:none;margin-top:44px;padding-bottom:4px;overscroll-behavior-x:contain}",
    ".rail6::-webkit-scrollbar{display:none}",
    ".ph6{flex:0 0 clamp(270px,25vw,340px);scroll-snap-align:start;min-height:440px;padding:28px 26px;display:flex;flex-direction:column;gap:14px;background:#10213a;border:1px solid rgba(201,163,107,.16);color:var(--hueso);transition:background .7s cubic-bezier(.2,.7,.2,1),color .7s,border-color .7s}",
    ".ph6 .mono{color:#C9A36B}",
    ".ph6 h3{margin:0;font-size:clamp(28px,2.3vw,38px);font-weight:300;letter-spacing:-.035em;line-height:1}",
    ".ph6 .ic6{flex:1;display:grid;place-items:center;min-height:150px;color:#C9A36B;transition:color .7s}",
    ".ph6 .ic6 svg{width:62%;max-width:150px;height:auto;overflow:visible}",
    ".ph6 p{margin:0;color:var(--niebla);font-size:14px;line-height:1.6;transition:color .7s}",
    ".ph6 .out6{display:flex;flex-direction:column;gap:4px;padding-top:14px;border-top:1px solid rgba(201,163,107,.2);color:var(--hueso)}",
    ".ph6 .out6 .mono{font-size:11px}",
    ".ph6.on{background:#F2EDE4;border-color:#F2EDE4;color:#0B1A2E}",
    ".ph6.on .ic6{color:#14253C}.ph6.on p{color:#3d4c60}.ph6.on .out6{color:#0B1A2E;border-color:rgba(20,37,60,.18)}.ph6.on .mono{color:#7A5A2E}",
    ".ph6 .sd{stroke-dasharray:1;stroke-dashoffset:1;transition:stroke-dashoffset 2.2s cubic-bezier(.65,0,.25,1)}",
    ".ph6 .f{stroke-opacity:.45}",
    ".phz6.in6 .ph6 .sd{stroke-dashoffset:0}",
    ".ph6:not(.on) svg *{animation:none!important}",
    ".ph6:not(.on) .ck{stroke-dashoffset:0}",
    ".bar6{position:relative;height:1px;margin-top:28px;background:rgba(201,163,107,.2)}",
    ".bar6 i{position:absolute;left:0;top:-1px;height:3px;width:20%;background:#C9A36B;transition:transform .7s cubic-bezier(.2,.7,.2,1)}",
    "@media (max-width:820px){.ph6{flex-basis:80vw;min-height:420px}.nav6 button{width:42px;height:42px}.phz6 .hd6{align-items:flex-start;flex-direction:column}}",
    // Planes
    ".pg6{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:20px;margin-top:56px;align-items:stretch}",
    ".pc6{display:flex;flex-direction:column;gap:18px;padding:34px 30px;background:#FBF8F2;border:1px solid rgba(11,26,46,.12);color:#0B1A2E}",
    ".pc6 .mono{margin:0;color:#7A5A2E}",
    ".pc6 h3{margin:0;font-size:clamp(32px,2.8vw,46px);font-weight:300;letter-spacing:-.04em;line-height:1}",
    ".pc6.no6{background:transparent;border-style:dashed}",
    ".pc6.no6 h3{font-size:clamp(24px,2vw,32px);line-height:1.15;letter-spacing:-.03em}",
    ".pc6 ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:11px;flex:1}",
    ".pc6 li{position:relative;padding-left:22px;font-size:15px;line-height:1.45}",
    ".pc6 li::before{content:'';position:absolute;left:0;top:.62em;width:11px;height:1px;background:#7A5A2E}",
    ".pc6 .x6 li{color:#5B6573;text-decoration:line-through;text-decoration-color:rgba(91,101,115,.6)}",
    ".pc6 .nt6{margin:0;font-size:15px;color:#0B1A2E}",
    ".pc6 .pr6{margin:0;display:flex;flex-direction:column;gap:4px;padding:16px 0;border-top:1px solid rgba(11,26,46,.12);border-bottom:1px solid rgba(11,26,46,.12)}",
    ".pc6 .pr6 b{font-size:clamp(28px,2.4vw,38px);font-weight:500;letter-spacing:-.025em}",
    ".pc6 .pr6 span{font-size:13px;color:#5B6573}",
    ".pc6 .btn{margin-top:8px;align-self:flex-start}",
    ".pc6.el6{background:#0B1A2E;border-color:#0B1A2E;color:#F2EDE4}",
    ".pc6.el6 .mono{color:#C9A36B}.pc6.el6 li::before{background:#C9A36B}.pc6.el6 .pr6{border-color:rgba(242,237,228,.16)}.pc6.el6 .pr6 span{color:#8A94A3}",
    ".ft6{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:28px;margin-top:40px;padding-top:26px;border-top:1px solid rgba(11,26,46,.15)}",
    ".ft6 b{display:block;font-weight:500;margin-bottom:6px;color:#0B1A2E}.ft6 span{color:#5B6573;font-size:14px;line-height:1.55}",
    "@media (max-width:900px){.pg6,.ft6{grid-template-columns:1fr}.pc6 .btn{align-self:stretch}}",
    ".panel .fig4.symf{background:#0a1628}",
    // Cierre con la barra 3D
    ".end6{position:relative;height:250vh;background:var(--abismo);color:var(--hueso)}",
    ".end6 .stick6{position:sticky;top:0;height:100vh;height:100svh;overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;padding-bottom:clamp(36px,7vh,96px);background:radial-gradient(90% 70% at 66% 34%,#16304f 0%,#0B1A2E 55%,#060f1c 100%)}",
    ".end6 canvas.e3{position:absolute;inset:0;width:100%;height:100%;display:block;opacity:0;transition:opacity 1.2s}",
    ".end6 .w4{position:relative;z-index:1;width:100%}",
    ".end6 .huge{margin:0;font-size:clamp(68px,15vw,260px);line-height:.82;font-weight:300;letter-spacing:-.06em;color:var(--hueso)}",
    ".end6 .huge span{color:var(--laton)}",
    ".end6 .row{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:flex-end;gap:28px;margin-top:clamp(32px,4vw,64px);padding-top:22px;border-top:1px solid var(--hair-d)}",
    ".end6 .row p{margin:0;color:var(--niebla);max-width:34ch}",
    "@media (max-width:820px){.end6{height:220vh}.end6 .huge{font-size:clamp(64px,19vw,120px)}}",
  ].join("");
  document.head.appendChild(css);

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function seg(p, a, b) { return ease(clamp((p - a) / (b - a), 0, 1)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ---------- revelación de las fases ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -12% 0px" });
    [].forEach.call(document.querySelectorAll(".phz .plist4 .fig4"), function (f) { io.observe(f); });
  } else {
    [].forEach.call(document.querySelectorAll(".phz .plist4 .fig4"), function (f) { f.classList.add("in"); });
  }

  /* ---------- fases: carrusel que avanza solo ---------- */
  (function () {
    var sec = document.querySelector(".phz6"); if (!sec) return;
    var rail = sec.querySelector(".rail6"), cards = [].slice.call(rail.children), bar = sec.querySelector(".bar6 i");
    var idx = 0, vis = false, hold = 0, timer = null, scrolling = false;
    function mark(i) {
      idx = (i + cards.length) % cards.length;
      cards.forEach(function (c, j) { c.classList.toggle("on", j === idx); });
      if (bar) bar.style.transform = "translateX(" + (idx * 100) + "%)";
    }
    function go(i) {
      mark(i); scrolling = true;
      rail.scrollTo({ left: cards[idx].offsetLeft - cards[0].offsetLeft, behavior: "smooth" });
      setTimeout(function () { scrolling = false; }, 700);
    }
    function pause(ms) { hold = Date.now() + (ms || 7000); }
    sec.querySelector(".pv6").addEventListener("click", function () { pause(); go(idx - 1); });
    sec.querySelector(".nx6").addEventListener("click", function () { pause(); go(idx + 1); });
    ["pointerdown", "touchstart", "wheel"].forEach(function (ev) { rail.addEventListener(ev, function () { pause(); }, { passive: true }); });
    rail.addEventListener("mouseenter", function () { pause(60000); });
    rail.addEventListener("mouseleave", function () { hold = 0; });
    var st;
    rail.addEventListener("scroll", function () {
      if (scrolling) return;
      clearTimeout(st); st = setTimeout(function () {
        var x = rail.scrollLeft, best = 0, d = 1e9;
        cards.forEach(function (c, j) { var dd = Math.abs(c.offsetLeft - cards[0].offsetLeft - x); if (dd < d) { d = dd; best = j; } });
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4 && best < cards.length - 1 && idx >= best) return;
        mark(best);
      }, 120);
    }, { passive: true });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) sec.classList.add("in6"); }, { threshold: 0.25 }).observe(sec);
    else { vis = true; sec.classList.add("in6"); }
    timer = setInterval(function () { if (vis && Date.now() > hold && !document.hidden) go(idx + 1); }, 3800);
    mark(0);
  })();

  /* ---------- carrete de los pilares ---------- */
  var reel = document.getElementById("reel5");
  if (!reel) return;
  var stick = reel.querySelector(".stick5"), tiles = [].slice.call(reel.querySelectorAll(".t5"));
  var head = reel.querySelector(".head5"), hint = reel.querySelector(".hint5");
  var caps = tiles.map(function (t) { return t.querySelector("figcaption"); });
  var vids = tiles.map(function (t) { return t.querySelector("video"); }).filter(Boolean);
  var goo = document.createElement("canvas"); goo.className = "goo5"; goo.setAttribute("aria-hidden", "true");
  stick.appendChild(goo);
  var gx = goo.getContext("2d");

  // Semillas de las manchas: [x, y, radio relativo, fase]
  var B = [[.5, .5, 1, 0], [.3, .38, .62, 1.3], [.72, .34, .7, 2.1], [.64, .72, .6, .7], [.32, .7, .66, 2.8], [.88, .58, .5, 1.9], [.12, .22, .48, .4], [.12, .85, .44, 3.3], [.9, .12, .46, 2.5]];
  var GW = 0, GH = 0, img = null, W = 0, H = 0, mob = false;
  function size() {
    W = stick.clientWidth; H = stick.clientHeight; mob = W < 820;
    GW = Math.max(140, Math.round(W / 4)); GH = Math.max(140, Math.round(H / 4));
    goo.width = GW; goo.height = GH; img = gx.createImageData(GW, GH);
  }
  size();
  window.addEventListener("resize", size);

  // Color hueso #F2EDE4 con un borde suave (antialias)
  function drawGoo(R, t) {
    if (R > 2.2) { goo.style.visibility = "hidden"; return; }
    goo.style.visibility = "visible";
    var d = img.data, asp = GW / GH, pts = B.map(function (b, i) {
      var r = (i === 0 ? 0.035 + R * 0.62 : Math.max(0, R - 0.18 - i * 0.03) * b[2] * 0.55);
      return [b[0] + Math.sin(t * 0.7 + b[3]) * 0.025, b[1] + Math.cos(t * 0.6 + b[3]) * 0.025, r * r];
    });
    var k = 0;
    for (var y = 0; y < GH; y++) {
      var fy = y / GH;
      for (var x = 0; x < GW; x++) {
        var fx = x / GW, f = 0;
        for (var i = 0; i < pts.length; i++) {
          var p = pts[i]; if (!p[2]) continue;
          var dx = (fx - p[0]) * asp, dy = fy - p[1];
          f += p[2] / (dx * dx + dy * dy + 1e-5);
        }
        // f >= 1 dentro de la mancha (transparente); afuera, color hueso
        var a = 1 - clamp((f - 0.94) / 0.12, 0, 1);
        d[k] = 242; d[k + 1] = 237; d[k + 2] = 228; d[k + 3] = a * 255;
        k += 4;
      }
    }
    gx.putImageData(img, 0, 0);
  }

  // Posiciones: nube flotante en 3D -> tríptico ordenado
  var CL = [
    { x: -0.17, y: 0.02, ry: 14, rz: -3, z: 60, s: 1.0 },
    { x: 0.15, y: -0.1, ry: -14, rz: 3, z: -40, s: 0.88 },
    { x: 0.02, y: 0.14, ry: 6, rz: -1, z: 20, s: 0.8 }
  ];
  function progress() {
    var r = reel.getBoundingClientRect(), h = r.height - window.innerHeight;
    return h <= 0 ? 0 : clamp(-r.top / h, 0, 1);
  }
  var onScreen = false;
  if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }, { rootMargin: "100px 0px" }).observe(reel);
  else onScreen = true;

  var t0 = performance.now(), ps = progress(), last = t0;
  function frame(now) {
    requestAnimationFrame(frame);
    if (!onScreen) { last = now; return; }
    var dt = Math.min((now - last) / 1000, 0.05); last = now;
    ps += (progress() - ps) * (1 - Math.exp(-dt * 6));   // resorte: sin saltos
    var t = (now - t0) / 1000, p = ps;
    var R = seg(p, 0.02, 0.34) * 2.4;            // apertura líquida
    drawGoo(R, t);
    if (R > 0.5) tiles.forEach(function (tl) { tl.classList.add("in6"); });
    if (hint) hint.style.opacity = (1 - seg(p, 0.02, 0.1)) * 0.7;

    var u = seg(p, 0.36, 0.72);                  // de la nube al tríptico
    var cw = mob ? W * 0.5 : Math.min(W * 0.24, H * 0.42);
    var gw = mob ? Math.min((W - 48) / 3, H * 0.2) : Math.min(W * 0.2, H * 0.39);
    var gap = mob ? 12 : Math.max(24, W * 0.03);
    tiles.forEach(function (tl, i) {
      var c = CL[i];
      var w = lerp(cw * c.s, gw, u), h = w * 4 / 3;
      var x = lerp(c.x * W * (mob ? 1.4 : 1), (i - 1) * (gw + gap), u);
      var y = lerp(c.y * H, mob ? H * 0.06 : H * 0.075, u);
      var ry = lerp(c.ry + Math.sin(t * 0.4 + i) * 2.5, 0, u);
      var rz = lerp(c.rz + Math.cos(t * 0.35 + i) * 1, 0, u);
      var z = lerp(c.z, 0, u);
      var fl = (1 - u) * Math.sin(t * 0.6 + i * 1.7) * 7;
      tl.style.width = w + "px"; tl.style.height = h + "px";
      tl.style.transform = "translate3d(" + (x - w / 2).toFixed(1) + "px," + (y - h / 2 + fl).toFixed(1) + "px," + z.toFixed(1) + "px) rotateY(" + ry.toFixed(2) + "deg) rotateZ(" + rz.toFixed(2) + "deg)";
      tl.style.zIndex = Math.round(100 + z);
      caps[i].style.opacity = seg(p, 0.62, 0.76);
      caps[i].style.transform = "translateY(" + ((1 - seg(p, 0.62, 0.76)) * 14) + "px)";
    });
    head.style.opacity = seg(p, 0.5, 0.68);
    head.style.transform = "translateY(" + ((1 - seg(p, 0.5, 0.68)) * 24) + "px)";
  }
  requestAnimationFrame(frame);

  // Videos: cargan y se reproducen solo mientras el carrete está en pantalla
  function play(v) { if (!v.src) v.src = v.getAttribute("data-src"); var q = v.play(); if (q && q.catch) q.catch(function () {}); }
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      vids.forEach(function (v) { if (es[0].isIntersecting) play(v); else if (v.src) v.pause(); });
    }, { rootMargin: "300px 0px" }).observe(reel);
  } else vids.forEach(play);
  ["touchstart", "pointerdown"].forEach(function (ev) {
    window.addEventListener(ev, function () { if (onScreen) vids.forEach(play); }, { passive: true });
  });
})();
